import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import CrUCRWLDCSKvJiLhBcNkXNuHPlJSjJaOm from "/vercel/path0/pkg/timvir/blocks/Message/samples/basic";
import CJjGMYrycRsyoyIzPirOHyzQCVlZCXUvG from "/vercel/path0/pkg/timvir/blocks/Message/samples/basic";
import CsWRzcUhqRfFpoLCGOSzBIRrxdjpkftoB from "/vercel/path0/pkg/timvir/blocks/Message/samples/basic";
import CrLbLDFFCIThjxvJvutsIMqlVhpafprxd from "/vercel/path0/pkg/timvir/blocks/Message/samples/basic";
import CDSOSAGsNjscMiKYJCMPXpYjAaHkefJVE from "/vercel/path0/pkg/timvir/blocks/Message/samples/basic";
import CBqLHYuUGEuntywFsGJjrFKePGgzHbzoF from "/vercel/path0/pkg/timvir/blocks/Message/samples/basic";
import {Exhibit} from "../../Exhibit";
import {Grid} from "../../Grid";
import {Swatch} from "../../Swatch";
import {Code} from "../../Code";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Message"
    }), "\n", _jsx(Exhibit, {
      children: _jsx(CBqLHYuUGEuntywFsGJjrFKePGgzHbzoF, {})
    }), "\n", _jsx(Code, {
      language: "jsx",
      children: "import * as React from \"react\";\nimport { Message } from \"..\";\n\ntype Props = Partial<React.ComponentPropsWithoutRef<typeof Message>>;\n\nexport default function Sample(props: Props) {\n  return <Message children={<>The component is a simple container for messages.</>} {...props} />;\n}\n"
    }), "\n", _jsx(_components.h2, {
      children: "Variants"
    }), "\n", _jsxs(Grid, {
      children: [_jsx(Exhibit, {
        caption: "info",
        children: _jsx(CDSOSAGsNjscMiKYJCMPXpYjAaHkefJVE, {
          variant: "info"
        })
      }), _jsx(Exhibit, {
        caption: "warning",
        children: _jsx(CrLbLDFFCIThjxvJvutsIMqlVhpafprxd, {
          variant: "warning"
        })
      }), _jsx(Exhibit, {
        caption: "alert",
        children: _jsx(CsWRzcUhqRfFpoLCGOSzBIRrxdjpkftoB, {
          variant: "alert"
        })
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Content"
    }), "\n", _jsx(_components.p, {
      children: "Make the title bold and place it before the message, or use a level 3 heading. You can use arbitrary markdown inside the message."
    }), "\n", _jsxs(Grid, {
      children: [_jsx(Exhibit, {
        caption: "Inline title",
        children: _jsx(CJjGMYrycRsyoyIzPirOHyzQCVlZCXUvG, {
          children: _jsxs(_components.p, {
            children: [_jsx(_components.strong, {
              children: "Short Messages"
            }), " should place the title in front of the message and make it stand out."]
          })
        })
      }), _jsx(Exhibit, {
        caption: "Title as a separate block elment",
        children: _jsxs(CrUCRWLDCSKvJiLhBcNkXNuHPlJSjJaOm, {
          children: [_jsx(_components.h3, {
            children: "Longer Messages"
          }), _jsxs(_components.p, {
            children: ["Longer messages should make the title a separate block element. This body uses ", _jsx(_components.a, {
              href: "#",
              children: "links"
            }), " and ", _jsx(_components.em, {
              children: "italic"
            }), " text."]
          }), _jsx(_components.p, {
            children: "And multiple paragraphs. And even a component:"
          }), _jsx(Swatch, {
            value: "#FF00FF"
          })]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      children: "References"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.atlassian.design/server/components/messages/",
          children: "ATLASSIAN Design: Messages"
        })
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
